// extracted by mini-css-extract-plugin
export default {"block":"Switch_block__Zl9C5","item":"Switch_item__FiwOv","slide":"Switch_slide__3o2Gv","dark":"Switch_dark__FtuzL","active":"Switch_active__g0MEZ","light":"Switch_light__AaLo7"};